<template>
  <transition
    name="dialog-fade"
    @after-enter="afterEnter"
    @after-leave="afterLeave">
    <div class="el-dialog__wrapper" v-show="visible" @click.self="handleWrapperClick">
      <div
        class="el-dialog"
        v-kyeresize="emitResize"
        :class="[{ 'is-fullscreen': fullscreen, 'el-dialog--center': center }, customClass]"
        ref="dialog"
        :style="style">
        <div class="el-dialog__header">
          <slot name="title">
            <span class="el-dialog__title">{{ title }}</span>
          </slot>
          <div @click="handleFullScreen" :style="fullscreenSwitch" :class="{'el-dialog-fullscreen__max': !fakeFullScreen, 'el-dialog-fullscreen__min': fakeFullScreen}" class="el-dialog-fullscreen"></div>
          <button
            type="button"
            class="el-dialog__headerbtn"
            aria-label="Close"
            v-if="showClose"
            @click="handleClose">
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>
        </div>
        <div class="el-dialog__body" :class="[dialogBodyClass]" v-if="rendered"><slot></slot></div>
        <div class="el-dialog__footer" v-if="$slots.footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import Popup from '../popup'
  import Migrating from 'element-ui/src/mixins/migrating'
  import emitter from 'element-ui/src/mixins/emitter'
  import { getDistance } from '@/public/utils/index'
  const SafeArea = {
    width: 200,
    height: 150 // 200 -> 150 最小高度 200 太高，会存在内容只有一行 form-item 的场景显示多余空白
  }
  export default {
    name: 'ElDialog',

    mixins: [Popup, emitter, Migrating],

    props: {
      title: {
        type: String,
        default: ''
      },

      canResize: {
        type: Boolean,
        default: true
      },

      showFullScreenButton: {
        type: Boolean,
        default: true
      },

      fullscreenEl: {
        type: Object,
      },

      modal: {
        type: Boolean,
        default: true
      },

      modalAppendToBody: {
        type: Boolean,
        default: true
      },

      appendToBody: {
        type: Boolean,
        default: false
      },

      lockScroll: {
        type: Boolean,
        default: true
      },

      closeOnClickModal: {
        type: Boolean,
        default: true
      },

      closeOnPressEscape: {
        type: Boolean,
        default: true
      },

      showClose: {
        type: Boolean,
        default: true
      },

      width: String,

      fullscreen: Boolean,

      customClass: {
        type: String,
        default: ''
      },

      top: {
        type: String,
        default: '15vh'
      },
      beforeClose: Function,
      center: {
        type: Boolean,
        default: false
      },
      dialogBodyClass: String
    },

    data() {
      return {
        closed: false,
        fakeFullScreen: false,
        isMousedown: false
      }
    },

    watch: {
      visible(val) {
        if (val) {
          this.closed = false
          this.$emit('open')
          this.$el.addEventListener('scroll', this.updatePopper)
          this.$nextTick(() => {
            this.$refs.dialog.scrollTop = 0
          })
          if (this.appendToBody) {
            document.body.appendChild(this.$el)
          }
        } else {
          this.$el.removeEventListener('scroll', this.updatePopper)
          if (!this.closed) this.$emit('close')
        }
      }
    },

    computed: {
      style() {
        let style = {}
        if (!this.fullscreen) {
          style.marginTop = this.top
          if (this.width) {
            style.width = this.width
          }
        }
        if (this.canResize) {
          style.overflow = 'auto'
          style.resize = 'both'
          style.minWidth = `${SafeArea.width}px`
          style.minHeight = `${SafeArea.height}px`
        }
        if (this.fakeFullScreen) {
          const elMain = this.fullscreenEl || document.querySelector('.el-main') || document.body
          if (elMain) {
            style.width = `${elMain.offsetWidth}px`
            style.height = `${elMain.offsetHeight}px`
            style.top = `0px`
            style.marginTop = `${elMain.offsetTop}px`
            style.left = `0px`
            style.marginLeft = `${elMain.offsetLeft}px`
          }
        } else if (this.oldPosition) {
            style.width = this.oldPosition.width
            style.height = this.oldPosition.height
            style.marginTop = this.oldPosition.marginTop
            style.marginLeft = this.oldPosition.marginLeft
            style.top = this.oldPosition.top
            style.left = this.oldPosition.left
        }
        return style
      },
      fullscreenSwitch() {
        let style = {}
        if (this.showFullScreenButton) {
          style.display = 'block'
        } else {
          style.display = 'none'
        }
        return style
      }
    },

    methods: {
      handleFullScreen() {
        if (this.fakeFullScreen === false) {
          this.savePosition()
        }
        this.fakeFullScreen = !this.fakeFullScreen
        this.handleFullData()
        try {
          this.adjustTable2()
          this.adjustTable()
        } catch (e) {
          console.error('dialog fullScreen', e)
        }
        this.$emit('onFullScreenChange', this.fakeFullScreen)
        this.$bus.$emit('on-full-screen-change', this.fakeFullScreen)
      },
      handleFullData() {
        const dialog = this.$refs.dialog
        const rect = dialog.getBoundingClientRect()
        this.oldHeight = rect.height
        this.hasResize = true
        this.isMousedown = true
      },
      savePosition() {
        const dialog = this.$refs.dialog || {}
        let {width, height, marginTop, marginLeft, top, left} = window.getComputedStyle(dialog) || {}
        if (marginLeft === '0px' && left === '0px') {
          marginLeft = (document.body.offsetWidth - dialog.offsetWidth) / 2 + 'px'
        }
        this.oldPosition = {
          width,
          height,
          marginTop,
          marginLeft,
          top,
          left
        }
      },
      emitResize() {
        this.$emit('onResize', this.$refs.dialog)
        try {
          this.adjustTable2() // 表格宽度自适应
          this.adjustTable() // 表格宽度自适应
        } catch (e) {
          console.error('dialog onresize', e)
        }
      },
      adjustTable() {
        const dialog = this.$refs.dialog || {}
        const likeCanvasTable = (dialog.querySelector && dialog.querySelector('.box')) || {}
        const canvasTable = likeCanvasTable.__vue__ && likeCanvasTable.__vue__.repaint ? likeCanvasTable.__vue__ : null
        // 当前表格是否拉高自适应，取决于数据是否满足高度（判断当前页数据高度最大高度是否满足拖拽后高度）
        if (canvasTable && this.hasResize) {
          // 更改弹窗高度限制
          if (dialog.querySelector('.kye-dialog-body')) {
            dialog.querySelector('.kye-dialog-body').style.maxHeight = 'none'
          }
          let h = parseInt(canvasTable.cHeight)
          if (this.oldHeight === 0) { // 二次打开弹窗
            const body = dialog.querySelector('.el-dialog__body')
            const header = dialog.querySelector('.el-dialog__header')
            const diffH = dialog.offsetHeight - (body.offsetHeight + header.offsetHeight)
            h += diffH
          } else {
            const rect = dialog.getBoundingClientRect()
            const diffH = rect.height - this.oldHeight
            this.oldHeight = rect.height
            h += diffH // 拉伸或者缩小
          }
          const rowHeight = 28
          let getHeight = function (headerHeight) {
            return headerHeight + 10 * canvasTable.rowHeight
          }
          let DEFAULT_HEIGHT = 32 + 10 * rowHeight
          if (canvasTable.options.headerHeight) {
            canvasTable.cHeight = h < 32 ? getHeight(canvasTable.options.headerHeight) : h
          } else {
            canvasTable.cHeight = h < 32 ? DEFAULT_HEIGHT : h
          }
          canvasTable.clearHScroll()
          canvasTable.$nextTick(() => {
            canvasTable.initScroll()
            canvasTable.calculate()
          })
        }
        canvasTable && canvasTable.repaint()
      },
      adjustTable2() {
        try {
          if (this.isMousedown === false) return
          let isTable2 = false
          const table2DomId = '#kye-table-v2__root'
          const table2WrapDomId = '#listbox_table2-wrap'
          const dialog = this.$refs.dialog || {}
          const dialogHeight = dialog.offsetHeight || 0
          // 更改弹窗高度限制
          if (dialog.querySelector('.kye-dialog-body')) {
            dialog.querySelector('.kye-dialog-body').style.maxHeight = 'none'
          }
          if (typeof dialog.querySelectorAll === 'function') {
            let tables = dialog.querySelectorAll(table2WrapDomId)
            if (tables.length === 0) {
              isTable2 = true
              tables = dialog.querySelectorAll(table2DomId)
            }
            if (tables.length === 0) return
            const tableParentStyle = (tables[0] && window.getComputedStyle(tables[0].parentNode)) || {}
            const paddingBottom = parseFloat(tableParentStyle.paddingBottom || 0)
            const borderBottom = parseFloat(tableParentStyle.borderBottomWidth || 0)
            const scrollHeight = 12
            // const paddingBottom2 = 12 // 下边距
            const footDoms = dialog.querySelectorAll('.el-dialog__footer')
            const footDom = Array.from(footDoms).find(dom => dom.offsetParent)
            const footerHeight = footDom ? footDom.offsetHeight : 0 // 底部分页

            tables.forEach(tableEl => {
              const tableVM = tableEl.__vue__
              const { verticalDistance } = getDistance(dialog, tableVM.$el)
              let maxHeight = dialogHeight - verticalDistance - scrollHeight - paddingBottom - borderBottom - footerHeight
              if (isTable2 && tableVM && tableVM._updateTableHeight) {
                const tableStyle = (window.getComputedStyle(tableEl)) || {}
                const paddingBottom = parseFloat(tableStyle.paddingBottom || 0)
                maxHeight = maxHeight - paddingBottom
                // TODO table2内部表格实现原因，不改内部没想到更优雅方式，目前只是通过视觉上的修改props
                tableVM.$props.maxHeight = maxHeight
                tableVM._updateTableHeight()
              } else {
                const table2 = tableVM.$refs.table
                if (table2) {
                  const tableStyle = (window.getComputedStyle(table2.$el)) || {}
                  const paddingBottom = parseFloat(tableStyle.paddingBottom || 0)
                  maxHeight = maxHeight - paddingBottom
                  tableVM.maxHeightVal = maxHeight
                  // 更新内部最大高度，避免重新计算高度
                  tableVM.options.maxHeight = maxHeight
                  table2._updateTableHeight()
                }
              }
            })
          }
        } catch (e) {
          console.error('dialog onresize adjustTable2', e)
        }
      },
      getMigratingConfig() {
        return {
          props: {
            'size': 'size is removed.'
          }
        }
      },
      handleWrapperClick() {
        if (!this.closeOnClickModal) return
        this.handleClose()
      },
      handleClose() {
        if (typeof this.beforeClose === 'function') {
          this.beforeClose(this.hide)
        } else {
          this.hide()
        }
      },
      hide(cancel) {
        if (cancel !== false) {
          this.$emit('update:visible', false)
          this.$emit('close')
          this.closed = true
        }
      },
      updatePopper() {
        this.broadcast('ElSelectDropdown', 'updatePopper')
        this.broadcast('ElDropdownMenu', 'updatePopper')
      },
      afterEnter() {
        this.$emit('opened')
      },
      afterLeave() {
        this.$emit('closed')
        this.fakeFullScreen = false
        this.oldHeight = 0
      },
      mousedown(e) {
        const dialog = this.$refs.dialog
        const rect = dialog.getBoundingClientRect()
        const l = rect.left + rect.width
        const t = rect.top + rect.height
        const distance = 16
        const x = e.clientX
        const y = e.clientY
        // 判断是否在可调整区域
        if (x < l && x > l - distance && y < t && y > t - distance) {
          this.oldHeight = rect.height
          this.hasResize = true
          this.isMousedown = true
        }
      }
    },

    mounted() {
      if (this.visible) {
        this.rendered = true
        this.open()
        if (this.appendToBody) {
          document.body.appendChild(this.$el)
        }
      }
      this.canResize && this.$refs.dialog && this.$refs.dialog.addEventListener('mousedown', this.mousedown)
    },

    destroyed() {
      this.canResize && this.$refs.dialog && this.$refs.dialog.removeEventListener('mousedown', this.mousedown)
      // if appendToBody is true, remove DOM node after destroy
      if (this.appendToBody && this.$el && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el)
      }
    }
  }
</script>

<style scope>
  .el-dialog-fullscreen {
    cursor: pointer;
    width: 16px;
    height: 16px;
    position: absolute;
    right: 42px;
    top: 15px;
    background-size: cover;
  }

  .el-dialog-fullscreen__max {
    width: 13px;
    height: 13px;
    background-image: url(../images/max.svg)
  }

  .el-dialog-fullscreen__min {
    background-image: url(../images/min.svg)
  }
</style>



// WEBPACK FOOTER //
// src/public/components/el-dialog/src/component.vue